module.exports = __webpack_public_path__ + "assets/higiena-cyfrowa.30ad537c.svg";